<template>
  <!--- PRINTING HEADER HERE ---->
  <div>
    <div
      ref="abs" 
      >
      <v-toolbar 
      :color="strongColor" 
      flat 
      dark>
        <v-layout 
        column>
          <v-toolbar-title 
          class="white--text">{{ getTitle }}</v-toolbar-title>
          <div class="white--text">*By Absolute Value</div>
        </v-layout>
      </v-toolbar>
      <!--- END: PRINTING HEADER HERE ---->

      <!--- PRINTING TABLE HERE ---->

      <div id="vue-instance">
        <b-table 
        :fields="fields" 
        :items="sortedArray" 
        hover/>
      </div>
    </div>
    <!--- END: PRINTING TABLE HERE ---->
    <div>
      <v-btn 
      :color="strongColor" 
      dark 
      @click="downloadWithCSS(clientName)">Download PDF</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import jsPDF from 'jspdf'
import EventBus from "@/main.js"
import { addSign, fixName, STRONG_COLOR } from "@/components/globals/consts.js"
import ClientsService from '@/services/ClientsService'
import { RMP_LOGO_SMALL } from "@/assets/rmp_logo"
import html2canvas from 'html2canvas'

export default {
  props: {
    nodeList: {
      type: [Object, Array],
      required: true,
      default: null
    },
    clientName: {
      type: String,
      required: true,
      default: null
    }
  },
  data() {
    return {
      fields: [
        { key: "attr", label: "Basic Desire", class: "text-left" },
        {
          key: "value",
          label: "Score",
          class: "text-right"
        }
      ],
      sortedArray: null,
      needsRendered: false,
      attrList: [],
      childNodeList: [],
      firstRender: true,
      strongColor: STRONG_COLOR,
      rmpLogoSmall: RMP_LOGO_SMALL,
    };
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user", "route"]),
    getTitle: function() {
      return fixName(this.clientName) + `'s Needs Ranking*`;
    }
  },
  watch: {
    needsRendered: {
      immediate: true,
      handler() {
        this.emitMethod("needsRendered", this.needsRendered);
      }
    }
  },
  created() {
    if (this.firstRender) {
      this.firstRender = false;
      this.childNodeList = this.nodeList;
      this.sortedArray = this.absSortedArray(this.childNodeList);
      for (let x in this.sortedArray) {
        this.sortedArray[x].value = addSign(this.sortedArray[x].value);
      }
    }
  },
  async mounted() {
    this.needsRendered = true;

    await EventBus.$on("barCheckedAttrs", checkedAttrs => {
      try {
        this.attrList = checkedAttrs;
        this.childNodeList = JSON.parse(JSON.stringify(this.nodeList));
        this.childNodeList = this.updateList(this.childNodeList);
        this.sortedArray = this.absSortedArray(this.childNodeList);
      } catch (e) {
        console.log(e);
      }
    });
  },
  beforeDestroy() {
    try {
      // nothing
      this.sortedArray = null;// .destroy()
      this.childNodeList= null;// .destroy()
      this.attrList= null;// .destroy()
      this.pdf= null;// .destroy()
      this.pdfCanvas= null;// .destroy()
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    absSortedArray: function(arr) {
      function compare(a, b) {
        if (Math.abs(a.value) > Math.abs(b.value)) {
          return -1;
        } else if (Math.abs(a.value) < Math.abs(b.value)) {
          return 1;
        }
        return 0;
      }
      return arr.sort(compare);
    },
    emitMethod(name, value) {
      EventBus.$emit(name, value);
    },
    openWindow() {
      this.window.open();
    },
    updateList(val) {
      let tempNodeList = [];
      try {
        for (let i of Object.entries(val)) {
          let o = {};
          o.attr = i[1].attr;
          if (this.attrList.length === 0) {
            o.value = addSign(+i[1].value);
            tempNodeList.push(o);
          } else if (this.attrList.includes(o.attr)) {
            o.value = addSign(+i[1].value);
            tempNodeList.push(o);
          }
        }
        return tempNodeList;
      } catch (e) {
        tempNodeList= null;// .destroy()
        console.log(`${e}`);
      }
    },
async downloadWithCSS (clientName) {

  let doc = new jsPDF({orientation: 'p', unit: 'pt', format: 'letter'});
  let pdfImageHeight = 150 + (23*this.$data.childNodeList.length) 
  let currYear = new Date().getFullYear();
  let paperWidth = 612;
  let paperHeight = 792;
  
  let logoHeight = 70;
  let logoWidth = 120;
  let footerMargin = 36;
  let topMargin = 36;
  let leftMargin = 36;
  let rightMargin = 36;
  let centeredMargin = paperWidth / 2;
  let stdMargin = 36;
  
  doc.addImage(
    this.rmpLogoSmall,
    "PNG",
    topMargin,
    leftMargin,
    logoWidth,
    logoHeight
  );

  
    const el = this.$refs.abs
    const options = {
      type: 'dataURL'
    }
    let absPNG = await this.$html2canvas(el, options)
    doc.addImage(
      absPNG,
      'PNG',
      150,
      150,
      300,
      pdfImageHeight
      )  
  
  
  
  /*let canvasElement = document.createElement('canvas')
  let canvas = await html2canvas(this.$refs.abs, { canvas: canvasElement, x: 0, y: 200, windowWidth: 1200, windowHeight: 800})  
    const abs = await canvas.toDataURL('image/png')
      doc.addImage(
      abs,
      'PNG',
      150,
      150,
      320, //image width
      pdfImageHeight  //image heigh
      )*/  

    doc.setFontSize(10);
    doc.text(
    `©2000-${currYear}. IDS Publishing Corporation. All rights reserved.`,
    paperWidth /2,
    paperHeight - footerMargin,
    "center")
    doc.save(`${clientName}'s Needs Ranking.pdf`)
        
  } // END downloadwithcss  
}

}
</script>
<style scoped>
.getTitle {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewClient/NeedsRanking.vue